<template>
  <div>
    <template v-if="loadedDocs && hasDocs">
      <div v-for="(kase, index) in cases" :key="index">
        <div class="documents-title">
          <translate>Case</translate> {{ kase.caseNumber }}
        </div>
        <documents-table-component
          :documents="kase.documents">
        </documents-table-component>
      </div>
    </template>
    <!-- Loader -->
    <loader-component v-if="!loadedDocs"></loader-component>
    <!-- Loader -->
    <message-component v-if="loadedDocs && !hasDocs" :level="'info'">
      <translate> There are no documents for this customer. </translate>
    </message-component>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import DocumentsTableComponent from '@/components/layout/utility/DocumentsTableComponent'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'
  import { loadItemsMixin } from '@/mixins/mixins'

  export default {
    name: 'documents-view',
    mixins: [loadItemsMixin],
    components: {
      DocumentsTableComponent,
      MessageComponent,
      LoaderComponent
    },
    data () {
      return {
        loadedDocs: false,
        mixin: {
          actionMethod: this.getCases,
          actionParams: { customer: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        customers: state => state.customerModule.customers,
        cases: state => state.caseModule.cases
      }),
      hasDocs () {
        return !!this.cases.reduce((allDocs, kase) => allDocs.concat(kase.documents), []).length
      }
    },
    methods: {
      ...mapActions([
        'getCases',
        'getFiles'
      ]),
      getCaseFiles (kase) {
        return this.getFiles(kase.id).then(documents => {
          kase.setDocuments(documents)
        }).catch((err) => {
          this.handleError(err)
        })
      }
    },
    created () {
      this.mixin.init.then(() => {
        let promiseArr = []
        for (let kase of this.cases) {
          promiseArr.push(this.getCaseFiles(kase))
        }
        Promise.all(promiseArr).then(() => {
          this.loadedDocs = true
        })
      })
    }
  }
</script>
<style lang="sass" scoped>
  .documents-title
    margin-top: 1rem
    margin-bottom: 0.5rem
    font-size: 13pt
</style>
